'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FRIENDS_TAB_COUNTS_QUERY_KEY } from '@/modules/players/v3/constants/friends';
import { nudgeFriendRequest } from '@/utils/actions/players/friends/nudgeFriendRequest';

export interface UseNudgeFriendRequestParams {
  uuid: string;
  friendUuid: string;
}

export const useNudgeFriendRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ uuid, friendUuid }: UseNudgeFriendRequestParams) => {
      const res = await nudgeFriendRequest({ uuid, friendUuid });
      if (res.error) {
        throw new Error(`Failed to nudge friend request: ${res.error}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRIENDS_TAB_COUNTS_QUERY_KEY] });
    },
  });
};
